import axios from 'axios'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const DGdairyInput = () => {

  const [sDate,setSdate] = useState()
  const [eDate,setEdate] = useState()
  const [program,setProgram] = useState()
  const [description,setDescription] = useState()


  const navigate = useNavigate()

const postDiary = () => {
  const dist = sessionStorage.getItem("dist"); // ✅ Get dist from session

  axios.post('https://lionsdirectoryapi.emedha.in/DGDiary/api/diary/post', {
    sDate,
    eDate,
    program,
    description,
    dist
  }).then((res) => {
    alert(res.data);
    setTimeout(() => navigate('/DG-diary'), 200);
  });
};


  return (
    <div className='conatner add-project-container'>
      <label>Start Date</label>
        <input type='date' className='form-control'  onChange={(e)=>setSdate(e.target.value)}/>
        <br></br>
        <label>End Date</label>
        <input type='date' className='form-control' onChange={(e)=>setEdate(e.target.value)}/>
        <br></br>
        <select id="pet-select" className='form-control' onChange={(e)=>setProgram(e.target.value)}>
          <option value="">------Select Program------</option>
          <option value="Club Official Visit">Club Official Visit</option>
          <option value="District Program">District Program</option>
          <option value="Multiple Program">Multiple Program</option>
          <option value="INTERNATIONAL PROGRAM">INTERNATIONAL PROGRAM</option>
          <option value="Other">Other</option>
        </select>
        <label>Description</label>
        <textarea type='text' rows={6} className='form-control' placeholder='Event Name' onChange={(e)=>setDescription(e.target.value)}/>
        <br></br>
      <button className='btn btn-danger mb-2' onClick={postDiary}>Submit</button>
      <br></br>
    </div>
  )
}

export default DGdairyInput